module.exports = __webpack_public_path__ + "static/IvarText-SemiBold-c3508d08accfe8be458504ed3cb16847.woff";